import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";
// import {
//   NotificationContainer,
//   NotificationManager,
// } from "react-notifications";
import { forgotPasword } from "actions/Auth";
import Alert from "@material-ui/lab/Alert";

const ForgotPassword = (props) => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const token = useSelector(({ auth }) => auth.token);
  const { loading, message, error } = useSelector(
    ({ commonData }) => commonData,
  );

  useEffect(() => {
    if (token !== null) {
      props.history.push("/");
    }
  }, [token]);

  return (
    <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3 md-6">
      <div className="app-login-main-content" style={{ width: "90%" }}>
        <div className="app-logo-content d-flex align-items-center justify-content-center">
          <Link
            className="logo-lg"
            to="/"
            title="FVS"
            onClick={(e) => e.preventDefault()}
          >
            <img
              style={{ paddingBottom: 5 }}
              src={require("assets/images/logo.jpg")}
              alt="FVS"
              title="FVS"
            />
            <br />
            <span style={{ fontSize: 16, color: "#fff" }}>
              <center>
                <IntlMessages id="app.name" />
              </center>
            </span>
          </Link>
        </div>

        <div className="app-login-content">
          <div className="app-login-header mb-2">
            <h4>
              {(message && <Alert severity="success">{message}</Alert>) || (
                <IntlMessages id="appModule.forgotPassword" />
              )}
            </h4>
            <h4>
              {(error && <Alert severity="error">{error}</Alert>) || null}
            </h4>
          </div>

          <div className="app-login-form">
            <form>
              <fieldset>
                <TextField
                  label={<IntlMessages id="appModule.username" />}
                  fullWidth
                  onChange={(event) => setEmail(event.target.value)}
                  defaultValue={email}
                  margin="dense"
                  variant="outlined"
                  className="mt-1 my-sm-3"
                />

                <div className="mb-3 d-flex align-items-center justify-content-between">
                  <Button
                    onClick={() => {
                      dispatch(forgotPasword({ email }));
                    }}
                    variant="contained"
                    color="primary"
                    disabled={loading}
                  >
                    {(loading && <CircularProgress size={20} />) || (
                      <IntlMessages id="appModule.resetPassword" />
                    )}
                  </Button>
                  <Link to="/" variant="contained" className="btn btn-light">
                    <IntlMessages id="appModule.signIn" />
                  </Link>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>

      {/* {message && NotificationManager.error(message)}
      <NotificationContainer /> */}
    </div>
  );
};

export default ForgotPassword;
